(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["p4-mega-menu"] && !Shopify.designMode) return;
  try {
    class P4Mega extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-mega-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-mega-panel]'));
      this.imgs = Array.from(this.querySelectorAll('[data-mega-img]'));
      this.tabs.forEach((tab) => {
        const i = tab.dataset.megaTab;
        tab.addEventListener('mouseenter', () => this.activate(i));
        tab.addEventListener('focus', () => this.activate(i));
      });
    }
    activate(i) {
      this.tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.megaTab === i));
      this.panels.forEach((p) => p.classList.toggle('is-active', p.dataset.megaPanel === i));
      this.imgs.forEach((im) => im.classList.toggle('is-active', im.dataset.megaImg === i));
    }
  }
  if (!customElements.get('p4-mega')) customElements.define('p4-mega', P4Mega);
  } catch(e) { console.error(e); }
})();

})();
